module.exports = __webpack_public_path__ + "static/media/home.b4ec3297.svg";